/*------------------------------------*\
    #MAIN
\*------------------------------------*/

(($) => {
    $(() => {
        /**
         *  If you need to create any additional functions please create them in seperate files
         *  and put them in js/components/FILE_NAME.js, structure them like the example
         *  function below and call them inside of the function chain below, passing in $ as
         *  an argument.


         * always use the WW namespace

WW.functionName = function($) {
    ...
    //and return 'this' to allow other functions to continue the WW chain.
    return this;
};

        */

        WW.start($)
            .checkCurrentMediaQuery.init($)
            .navbar($)
            .peppermintSlider($)
            .sticky($)
            .imgControl.init($)
            .styledSelect($)
            .toggleUiPopup($)
            .allEqualHeights($)
            .modalDialog($)
            .sectionCollapse($)
            .thumbnailGallery($)
            //.instagramFeed($) 
            .stepperControl($)
            .screenResizeEvents($,
                WW.checkCurrentMediaQuery.init
                // pass in function names as arguments.
                // e.g :
                //WW.navbar,
                //WW.peppermint
            );
    });
})(jQuery);

/**
 * Just trigger popup windows. Useful for example when sharing. Just add .popup to the link and it will be
 * opened in a popup window. Attributes data-width and data-height can control the size of the window. Default is
 * 600x500 px.
 *
 * @author Johan Palmfjord <johan@wasabiweb.se>
 * @copyright Wasabi Web Ab, 2015
 */
;(function($) {
    $(function() {
        $('.js-popup').on('click', function (e) {
            var width = $(this).data('width') ? $(this).data('width') : '600',
                height = $(this).data('height') ? $(this).data('height') : '500',
                popup = window.open(
                    $(this).attr('href'),
                    $(this).attr('title'),
                    'width=' + width + ',height=' + height + ',scrollbars=no'
                );

            if (popup) {
                e.preventDefault();
            } else {
                $(this).attr('target', '_blank');
            }
        });
    });
})(jQuery);
